import { Alert, ListItem, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { SelectFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import { ListComponentWithIcon } from "../ListComponentWithIcon";
import { SpinnerWrapper } from "../SpinnerWrapper";
import TextScrollX from "../TextScrollX";
import { Accomplishment } from "../../models/Accomplishment";
import { Typography } from "@mui/material";
import AutoCompleteUIDTO from "../../dto/AutoCompleteUIDTO";
import { DateFieldComponent } from "../DatePicker";
import { AccomplishmentType } from "../../models/AccomplishmentType";

interface Props {
  isLoading: boolean;
  register: any;
  control: any;
  errors: any;
  instance: Accomplishment;
  setLinks: (links: string[]) => void;
  links: string[];
  accomplishmentTypes: AccomplishmentType[] | undefined;
  userAssignations: AutoCompleteUIDTO[] | undefined;
  getAccomplishmentData: (externalId: string) => AccomplishmentType | undefined;
}

export default function AccomplishmentCreateModal({
  isLoading,
  register,
  control,
  errors,
  instance,
  setLinks,
  links,
  accomplishmentTypes,
  userAssignations,
  getAccomplishmentData,
}: Props) {
  const [roleText, setRoleText] = useState();
  const [selectedType, setSelectedType] = useState<AccomplishmentType>();

  useEffect(() => {
    if (roleText) {
      const type = getAccomplishmentData(roleText);
      setSelectedType(type!);
    }
  }, [roleText]);

  return (
    <>
      <SpinnerWrapper isLoading={isLoading}>
        <SelectFieldComponent
          control={control}
          register={register}
          errors={errors}
          propertyName={"type.externalId"}
          label={"Type"}
          required={true}
          options={
            accomplishmentTypes
              ? accomplishmentTypes?.map((t) => {
                  return { label: t.title, value: t.externalId! };
                })
              : []
          }
          customHelperText={"some text"}
          internalSelectProps={{
            onChange: (event: any) => {
              setRoleText(event.target.value);
            },
          }}
        />
        <SelectFieldComponent
          control={control}
          register={register}
          errors={errors}
          propertyName={"assignation.externalId"}
          label={"Role"}
          required={false}
          options={
            userAssignations
              ? [
                  { label: "No role", value: "No role" },
                  ...userAssignations.map((a) => {
                    return { label: a.label, value: a.externalId };
                  }),
                ]
              : []
          }
        />
        {roleText !== undefined && (
          <Alert severity="info">
            <Typography style={{ fontWeight: "bold" }}>{"Approval conditions"}</Typography>
            <Typography>
              {selectedType?.approvalConditions}
              {selectedType?.additionalInfo?.map((i) => (
                <>
                  <ListItem children={`- ${i}`} />
                </>
              ))}
            </Typography>
            <br />
            <Typography style={{ fontWeight: "bold" }}>{"Approval accreditation data"}</Typography>
            <Typography>{selectedType?.approvalAccreditationData}</Typography>
            <br />
            <Typography style={{ fontWeight: "bold" }}>{"Approval needed by"}</Typography>
            <Typography>{selectedType?.approvalBy}</Typography>
            <br />
            <Typography style={{ fontWeight: "bold" }}>{"Points"}</Typography>
            <Typography>{selectedType?.points}</Typography>
          </Alert>
        )}

        <DateFieldComponent
          control={control}
          register={register}
          errors={errors}
          propertyName={"reportedOn"}
          label="Performed on"
          required={true}
          clearable={true}
          toUTC
        />

        <ListComponentWithIcon
          title={"Additional info"}
          name="links-accomplishment"
          items={links}
          renderItem={(item, index) => <TextScrollX key={index}>• {item}</TextScrollX>}
          onAdd={(newItem: string) => setLinks([...links, newItem])}
          onDelete={(itemIndex) => setLinks(links.filter((item, index) => index !== itemIndex))}
        />
      </SpinnerWrapper>
    </>
  );
}

const Input = styled("input")({
  display: "none",
});
